import styled from '@emotion/styled';
import React from 'react';
import { Button } from '@modernhealth/vital-components';
import { Modal } from 'src/shared/components/Modal';
import { font, layout } from 'src/shared/styles/variables';

const StyledModal = styled(Modal)({
    '&.ant-modal': {
        height: 'auto',
        borderRadius: '20px',
        top: '208px',
    },
    '.ant-modal-header': {
        border: 'none',
        padding: 'none',
    },
    '.ant-modal-body': {
        padding: '18px 20px 22px',
    },
    '.ant-modal-content': {
        height: 'auto',
        width: '412px',
        maxWidth: layout.modalWidth.wide,
        margin: '0 auto',
    },
});

const Header = styled.h3(
    {
        textAlign: 'left',
    },
    font.heavy(font.size.medium),
);

const Description = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    p: {
        marginBottom: '24px',
    },
});
interface DisclaimerModalProps {
    closable?: boolean;
    visible: boolean;
    title?: string;
    buttonText: string;
    description: string[];
    onClick: () => void;
}

export enum DisclaimerModalTestID {
    Modal = 'DisclaimerModal.Modal',
    Title = 'DisclaimerModal.Header',
    Description = 'DisclaimerModal.Description',
}

export const DisclaimerModal: React.FC<DisclaimerModalProps> = ({
    closable = false,
    visible,
    title,
    description,
    onClick,
    buttonText,
}) => {
    return (
        <StyledModal
            wrapProps={{
                'data-testid': DisclaimerModalTestID.Modal,
            }}
            closable={closable}
            visible={visible}
            footer={null}
        >
            {title && <Header data-testid={DisclaimerModalTestID.Title}>{title}</Header>}
            <Description data-testid={DisclaimerModalTestID.Description}>
                {description.map((text, index) => (
                    <p key={DisclaimerModalTestID.Description + `-${index}`}>{text}</p>
                ))}
            </Description>
            <Button variant="primary" fluid onClick={onClick}>
                {buttonText}
            </Button>
        </StyledModal>
    );
};
